import * as React from "react";
import { Link } from "react-router-dom";
import { BulbTwoTone, HomeTwoTone, PlayCircleTwoTone } from "@ant-design/icons";
import { Button, Card, Col, Divider, Row } from "antd";

import "./index.css";

const HomePage = () => {
  return (
    <>
      <div className="top-page">
        <div className="box-title">
          <h1>&lt;b&gt;CyTrain&lt;/b&gt;</h1>
          {/* eslint-disable-next-line react/jsx-no-comment-textnodes */}
          <p>// Online security training for everyone</p>
        </div>
        <br />
        <br />
        <Col>
          <Link to="/lectures">
            <Button danger type="primary" size="large">
              さっそく始めてみる
            </Button>
          </Link>
        </Col>
      </div>
      <Divider type="horizontal">この講座について</Divider>
      <Row>
        <Col xs={24} md={24} lg={8}>
          <Card bordered={false} style={{ margin: 20 }}>
            <h3>
              <HomeTwoTone twoToneColor="pink" /> すべてオンライン
            </h3>
            <p>
              時間や場所に囚われない今の暮らしに合ったスタイル。いつでもどこでも受講できます。
            </p>
          </Card>
        </Col>
        <Col xs={24} md={24} lg={8}>
          <Card bordered={false} style={{ margin: 20 }}>
            <h3>
              <BulbTwoTone twoToneColor="orange" /> 現代人に必要な教育内容
            </h3>
            <p>
              毎日何時間も使うのに学校では教わらなかったITセキュリティ。毎日使うものだから安全に。
            </p>
          </Card>
        </Col>
        <Col xs={24} md={24} lg={8}>
          <Card bordered={false} style={{ margin: 20 }}>
            <h3>
              <PlayCircleTwoTone /> 受講料無料
            </h3>
            <p>インターネットを使うすべての人々に無償で提供されています。</p>
          </Card>
        </Col>
      </Row>
      <Row justify="space-around">
        <Link to="/about">
          <Button type="primary" size="large">
            もっと詳しく
          </Button>
        </Link>
      </Row>
    </>
  );
};

export default HomePage;
